import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';

import { PH_EIS_MENU_MODE_HEADER } from '../services/ph-eis-menu-mode';
import { PhEisMenuModeService } from '../services/ph-eis-menu-mode.service';

/**
 * Tells AppController and Report Center which PH EIS menu to build.
 * The mode is the service's page-load signal: slim by default, full only for
 * the page load that consumed the one-shot switch handoff. The server ignores
 * the header unless `ph_eis.enabled` is on.
 */
export const phEisMenuModeInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.includes('api/')) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        [PH_EIS_MENU_MODE_HEADER]: inject(PhEisMenuModeService).mode()
      }
    })
  );
};
